import { reactive } from "@vue/composition-api"

export default function useLoadingDefault(){
    const loading = reactive({
        overlay : false,
        spinner : false,
        btnSave : false
    })
    return {
        loading
    }
}